<template>
    <li>
        <button
            @click="isOpen = !isOpen"
            type="button"
            class="btn btn-toggle dropdown-toggle text-start w-100 border-0"
        >
            <i :class="`bi bi-${icon}`"></i>
            {{ title }}
        </button>
        <transition name="dropdown">
            <ul v-show="isOpen" class="list-unstyled">
                <slot></slot>
            </ul>
        </transition>
        <hr v-if="addDivider" class="my-2 mx-4" />
    </li>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    title: String,
    icon: String,
    addDivider: Boolean // Prop to control divider rendering
})

const isOpen = ref(false)
</script>
